export default {
  defaultProps: {
    underline: 'none',
  },
} as const;
